import React from 'react';
import UserMessage from './UserMessage';
import AssistantMessage from './AssistantMessage';
import SourcesList from './SourcesList';

export default function MessageItem({
  message,
  index,
  messages,
  isDarkMode,
  chatSessionId = '',
  resources,
}) {
  if (
    !message.content ||
    (typeof message.content === 'string' && message.content.trim() === '')
  ) {
    return null;
  }

  const isUser = message.role === 'user';
  const isAI = message.role === 'ai';
  const isSystem = message.role === 'system';

  const formattedTime = message.timestamp
    ? new Date(message.timestamp).toLocaleString([], {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      })
    : '';

  return (
    <div className={`w-full ${index === 0 ? 'mt-3' : 'mt-4'}`}>
      {isUser ? (
        <UserMessage message={message} isDarkMode={isDarkMode} />
      ) : (
        <AssistantMessage
          message={message}
          messages={messages}
          isDarkMode={isDarkMode}
          chatSessionId={chatSessionId}
          formattedTime={formattedTime}
          isAI={isAI}
          isSystem={isSystem}
        />
      )}

      {(isAI || isSystem) && (
        <SourcesList resources={resources} isDarkMode={isDarkMode} />
      )}
    </div>
  );
}
